'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = exports.transform = exports.side = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _styledSystem = require('styled-system');

var _grid = require('@rebass/grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  left: 'translateX(-100%)',
  right: 'translateX(100%)',
  top: 'translateY(-100%)',
  bottom: 'translateY(100%)'
};
var side = exports.side = function side(_ref) {
  var side = _ref.side;

  if (!transforms[side]) return {
    top: 0,
    left: 0,
    bottom: 0
  };
  var h = /^(left|right)$/.test(side) ? 1 : 0;
  var top = /^(top|left|right)$/.test(side) ? 0 : null;
  var bottom = /^(bottom|left|right)$/.test(side) ? 0 : null;
  var left = /^(left|top|bottom)$/.test(side) ? 0 : null;
  var right = /^(right|top|bottom)$/.test(side) ? 0 : null;

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
};

var transform = exports.transform = function transform(_ref2) {
  var open = _ref2.open,
      side = _ref2.side;
  return {
    transform: open ? null : transforms[side] || transforms.left
  };
};

var Drawer = exports.Drawer = (0, _components2.default)({
  extend: _grid.Box,
  blacklist: ['side', 'open'],
  position: 'fixed',
  color: 'white',
  bg: 'black',
  open: false,
  side: 'bottom',
  width: 320
}, side, transform, 'position', 'zIndex', 'height', {
  overflowX: 'hidden',
  overflowY: 'auto',
  transitionProperty: 'transform',
  transitionDuration: '.2s',
  transitionTimingFunction: 'ease-out'
});

Drawer.displayName = 'Drawer';

exports.default = Drawer;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Drawer.js
// module id = 128
// module chunks = 22676092666560 46504955462500 107818501498521 221374088121123